module.exports = __webpack_public_path__ + "img/bg_1.5f422b1e.png";